interface EnvironmentProps {
  sentryDSN: string;
  enableSentry: boolean;
  sentryEnvironment?: string;
  release: string;
  environmentLabel?: string;
}

interface AppManifestV0 {
  name: string;
  menuName?: string;
  parentMenuName?: string;
  hideMenu?: boolean;
  path: string;
  rootnode: string;
  entrypoint: string;
  assets: string[];
  icon?: string;
  childRoutes?: { path: string; menuName: string }[];
  viewEngine: {
    name: string;
    version?: string;
  };
  environmentProps: EnvironmentProps;
}

const isString = (val: {}) => typeof val === 'string' || val instanceof String;

const parseEnvironmentProps = (props: EnvironmentProps) => {
  const environmentProps: EnvironmentProps = {
    sentryDSN: '',
    enableSentry: false,
    sentryEnvironment: undefined,
    release: 'unspecified',
    environmentLabel: undefined,
  };
  if (isString(props.sentryDSN)) {
    environmentProps.sentryDSN = props.sentryDSN;
  }
  if (props.enableSentry === true) {
    environmentProps.enableSentry = true;
  } else if (isString(props.enableSentry)) {
    environmentProps.enableSentry =
      String(props.enableSentry).toLowerCase() === 'true';
  }
  if (
    props.sentryEnvironment != null &&
    String(props.sentryEnvironment).length > 0
  ) {
    environmentProps.sentryEnvironment = String(props.sentryEnvironment);
  }
  if (props.release != null && String(props.release).length > 0) {
    environmentProps.release = String(props.release);
  }
  if (
    props.environmentLabel != null &&
    String(props.environmentLabel).length > 0
  ) {
    environmentProps.environmentLabel = String(props.environmentLabel);
  }

  return environmentProps;
};

const parse = (json: AppManifestV0): AppManifestV0 => {
  let environmentProps: EnvironmentProps = {
    sentryDSN: '',
    enableSentry: false,
    sentryEnvironment: undefined,
    release: 'unspecified',
    environmentLabel: undefined,
  };
  if (
    typeof json.environmentProps === 'object' &&
    !(json.environmentProps instanceof Date)
  ) {
    environmentProps = {
      ...environmentProps,
      ...parseEnvironmentProps(environmentProps),
    };
  }
  return {
    ...json,
    environmentProps: {
      ...json.environmentProps,
      ...environmentProps,
    },
  };
};

export { EnvironmentProps, AppManifestV0, parse };
